<template>
<!-- This template version is for 1-3 interactive boxes above the video frame -->
  <div class="hpHero" @mousemove="onMouseMovement" >
<!--     <div class="debug1">
        {{timerCounter}} showBoxes = {{showBoxes}}
    </div>
 -->    
    <div class="hpHeroInner">
        <video v-if="itemsData[hoverIndex].video.length>0" id="hpVideo1"
                data-src=""
                poster=""
                title=""
                autoplay=""
                loop=""
                muted=""
                :src="itemsData[hoverIndex].video">
        </video>
        <img v-if="itemsData[hoverIndex].bg.length>0"
            :src="itemsData[hoverIndex].bg" />
    </div>
    <div class="hpHeroContent">
        <div :class="['hphGrid',showBoxes ? 'active':'']">
            <div :class="['hphItem',showBoxes ? 'active':'']" @mouseover="onItemOver(index)" 
                :style="'--index:'+index"
                v-for="(item,index) in itemsData" :key="'hph_'+index">
                <div class="hphInner">
                    <div class="hph-arrow">
                        <i class="fal fa-chevron-right pl-s"></i>
                    </div>
                    <div class="hph-elements">
                        <div class="hph-img" v-if="item.img.length>0">
                            <img :src="item.img" />
                        </div>
                        <div class="hph-title" v-if="item.title.length>0">
                            {{item.title}}
                        </div>
                        <div class="hph-subtitle">
                            {{item.subtitle}}
                        </div>
                    </div>
                </div>
                
                
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
        //
        showBoxes:false,
        timerInt:null,
        timerCounter:0,
        hoverIndex:0,
        videoBgSrc:'',
        itemsData:
        [
          {
            "title":"",
            "subtitle":"New. Sharp. Every Single Time",
            "url":"https://www.mis-implants.com/products/kits-and-tools/xd-drills",
            "img":"logos/logo_xd.png",
            "video":"video/xd_sharp_1080.mp4",
            "bg":""
          },
          {
            "title":"",
            "subtitle":"Tissue-Level Screw-Retained Solution",
            "url":"https://www.mis-implants.com/products/prosthetic-options/screw-retained/connect-system",
            "img":"logos/logo_mis_connect.png",
            "video":"video/mis_connect.mp4",
            "bg":""
          },
          {
            "title":"",
            "subtitle":"Save the Date!",
            "url":"https://www.mis-implants.com/products/prosthetic-options/screw-retained/connect-system",
            "img":"https://www.mis-implants.com/img/product-logos/palma_logo4.svg",
            "video":"",
            "bg":"https://www.mis-implants.com/upload/Home/Global/hero-palma_2.jpg"
          }

          /*
          {
            "title":"Welcome to MIS Implants",
            "subtitle":"Making it Simple for over 25 years",
            "url":"https://www.mis-implants.com/products/kits-and-tools/xd-drills",
            "img":""
          }*/
        ]        
    };
  },
  mounted() {
    var vm = this;
    //vm.initVideoEvents();
  },
  watch: {
  },
  computed: {
  },
  methods: {
    initVideoEvents()
    {
      //alert("initVideoEvents");
      //document.getElementById('hpVideo1').addEventListener('ended',this.onHpVideoEnded,false);
      document.getElementById('hpVideo1').addEventListener('ended', function(e) {

          alert('The End');

      });

    },
    onHpVideoEnded(e)
    {
      alert("video completed");
    },
    onMouseMovement()
    {
        var vm = this;
        //vm.timerCounter=0;
        //vm.showBoxes = true;
    },
    onItemOver(index)
    {
        this.hoverIndex = index;
    }
  }
};
</script>

<style scoped>
    .hpHero
    {
        display: block;
        position: relative;
        height: 75vh;
        overflow: hidden;
    }
    .debug1
    {
        position: fixed;
        top: 200px;
        left: 200px;
        color: #fff;
        border: solid 2px red;
        padding: 5px;
        z-index: 10000;
    }
    .hpHero .hpHeroContent
    {
        position: absolute;
        bottom: 0px;
        height: auto;
        width: 100%;
        text-align: center;
        padding: 10vw 10vw 3vw 10vw;
        
    }
    .hphGrid
    {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0px;
        gap: 20px;
        flex-wrap: wrap;
        margin: 0px;       
        /* opacity: 1; transition: all ease 0.4s; */
    }
    .hphGrid.active
    {
        /* opacity: 1; */
    }
    .hphItem
    {
        cursor: pointer !important;
        flex: 1;
        height: 12vw;
        background-color: rgba(255, 255, 255, 0.1);        
        /* clip-path: inset(0 50% 0 0); */
        opacity: 0;        
        transition: all ease 1s;
        transition-delay: calc(var(--index) * 0.1s);
        
    }
    .hphItem.active
    {
        opacity: 1;
        /* clip-path: inset(0 0 0 0); */
    }


    .hphItem:hover
    {
        background-color: rgba(11, 11, 11, 0.75);
    }





    .hpHero .hpHeroContent img
    {
        width: 40vh;
        height: auto;
    }
    .hpHero .hpHeroContent h4
    {
        padding-top:10px;
        text-align: center;
        font-weight: 500 !important;
        font-size: 1.5vw;
    }
    .hpHeroInner
    {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000;
    }
    .hpHeroInner video,
    .hpHeroInner img
    {
        opacity: 0.8;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;        
    }
.textLink span
  {
    color: #fff;
    font-weight: 500 !important;
    border-radius: 30px;
    padding: 10px 20px;
    border: solid 2px #fff;
  }
  .btnWrap
  {
    clear: both;
    padding-top: 2vw;
  }

  .hphInner
  {
    position: relative;
    padding: 2.5vw;
    height: 100%;
    cursor: pointer !important;
  }


.hphItem:hover .hph-arrow
{
    opacity: 0.6;
    transform: translateX(-50%);
}
  .hph-arrow
  {
    position: absolute;
    bottom: 2.5vw;
    right: 1.25vw;
    color: #fff;
    font-size: 1.3vw;
    transform: translateX(-100%);
    opacity: 0;
    transition: all ease 0.4s;
  }
  .hph-elements
  {
    position: absolute;
    bottom: 2.5vw;
  }

    .hph-img
    {
        clear: both;
        text-align: left;
        padding-bottom: 1px;
    }
    .hph-img img
    {
        height: 2.6vw !important;
        width: auto !important;
    }
    .hph-title
    {
        color: #fff;
        font-weight: 300 !important;
        text-align: left;
        font-size: clamp(2vw,2.4vw,4.5rem);
        line-height: clamp(2vw,2.2vw,4.5rem);
        padding-bottom: 10px;
        letter-spacing: -1px !important;
    }
    .hph-subtitle
    {
        text-align: left;
        color: #fff;
        font-weight: 300 !important;
    }


    


</style>
